export type TValidGraphType = 'Bar' | 'Stacked bar percent' | 'Stacked bar count';

export interface IBarGraphData {
  group: any;
  value: number;
}

export interface IStackedBarGraphData {
  group: any;
  [key: string]: number;
}

export interface IxAxisRotation {
  labelAnchor: string;
  rotation: number;
}

export enum VizDataType {
  Percent = 'Percent',
  Count = 'Count',
}
